/**
 * Onboarding persistence — the `bjjmap:` localStorage key that gates the
 * first-run coach-mark tour.
 *
 * All access goes through here so the namespace stays consistent and every
 * read/write is guarded: localStorage throws in Safari private mode and is
 * absent in non-DOM contexts, so we swallow and degrade to "not seen"
 * rather than crashing the app on boot.
 */

export const SEEN_TOUR = 'bjjmap:seen-tour';

function safeGet(key: string): string | null {
  try {
    return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
  } catch {
    return null;
  }
}
function safeSet(key: string, value: string): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(key, value);
  } catch {
    /* private mode / quota — silently degrade */
  }
}
function safeRemove(key: string): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Boolean flag helpers (presence of the key == "seen / done"). */
export const flag = {
  isSet: (key: string): boolean => safeGet(key) !== null,
  set: (key: string): void => safeSet(key, '1'),
  clear: (key: string): void => safeRemove(key),
};
